import { render, staticRenderFns } from "./FundsSumBlock.vue?vue&type=template&id=1fca720b&scoped=true"
import script from "./FundsSumBlock.vue?vue&type=script&lang=js"
export * from "./FundsSumBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fca720b",
  null
  
)

export default component.exports